import Icon from '../components/Icon.vue'

Icon.register({"long-arrow-right":{"width":1792,"height":1792,"paths":[{"d":"M1728 893q0 14-10 24l-384 354q-16 14-35 6-19-9-19-29v-224h-1248q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h1248v-224q0-21 19-29t35 5l384 350q10 10 10 23z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/long-arrow-right.js
// module id = 909
// module chunks = 0